export const TASK_RAMBO_LIST_REQUEST  = 'TASK_RAMBO_LIST_REQUEST';
export const TASK_RAMBO_LIST_SUCCESS  = 'TASK_RAMBO_LIST_SUCCESS';
export const TASK_RAMBO_LIST_FAIL     = 'TASK_RAMBO_LIST_FAIL';

export const TASK_BAMBOU_LIST_REQUEST  = 'TASK_BAMBOU_LIST_REQUEST';
export const TASK_BAMBOU_LIST_SUCCESS  = 'TASK_BAMBOU_LIST_SUCCESS';
export const TASK_BAMBOU_LIST_FAIL     = 'TASK_BAMBOU_LIST_FAIL';